import Window from 'window-or-global'
import EventBus from '@/services/bus'

export const clearErrorByKey = request => {
  // Clear any error from a previous request with the same method (get, post etc) and URL
  EventBus.$emit('CLEAR_ERROR_BY_KEY', request.method + request.url)

  return request
}

export const setHeaderFromCookie = request => {
  if (request.url && request.url.match(/s3.amazon/) !== null) {
    request.headers = {}

    return request
  }
  const cookies = Window.document.cookie ? Window.document.cookie.split('; ') : []
  const jar = {}
  cookies.forEach(c => {
    let crumbs = c.split('=')
    jar[crumbs[0]] = crumbs[1]
  })
  if (jar.access_token) {
    request.headers = { Authorization: `Bearer ${jar.access_token}` }
  }

  return request
}
